import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
import Colors from '../../../../shared/assets/style/default/color';

const NetworkScreenContainer = styled.div<React.CSSProperties>`
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  height: ${1080 * Screen.widthRatio}px;
  top: 0;
  background: ${Colors.modal.dial.background};
  z-index: 1;
  text-align: center;
`;

export default withAnimation(NetworkScreenContainer);
